import React from 'react';
import { useMutation, useQuery, useQueryClient } from 'react-query';
import { reinsuredApi } from 'services/apis';
import { useParams } from 'react-router';
import ReinsuredForm from 'components/features/reinsured-form';
import { CreateReinsuredPayloadDto } from 'libs/pinnacle-sdk';
import { EQueryKeys } from 'constants/query-keys';

const UpdateReinsuredForm: React.FC = () => {
  const { id } = useParams<{ id: string }>();
  const queryClient = useQueryClient();

  const { data: reinsured, isLoading: isFetchingReinsured } = useQuery(
    [EQueryKeys.REINSURED_BY_ID, id],
    () => reinsuredApi.getReinsuredById({ reinsuredId: id as string }),
    {
      enabled: !!id,
    }
  );

  const updateReinsuredMutation = useMutation<
    void,
    Error,
    CreateReinsuredPayloadDto
  >(async (updatedReinsured) => {
    await reinsuredApi.updateReinsured({
      reinsuredId: id as string,
      updateReinsuredPayloadDto: updatedReinsured,
    });
    await Promise.all([
      queryClient.invalidateQueries([EQueryKeys.REINSURED_BY_ID, id]),
      queryClient.invalidateQueries([EQueryKeys.REINSURED_LIST]),
    ]);
  });

  return (
    <ReinsuredForm
      mode="update"
      initialData={reinsured}
      onSubmit={updateReinsuredMutation.mutateAsync}
      isLoading={isFetchingReinsured || updateReinsuredMutation.isLoading}
    />
  );
};

export default UpdateReinsuredForm;
